import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import DocumentationFilePreview from './DocumentationFilePreview';

loadDOMComponent({
	selector: 'react-documentation-file-preview',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const documentationFileId = container.getAttribute(
			'data-documentationFileId',
		);
		const className = container.getAttribute('data-className');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<DocumentationFilePreview
						documentationFileId={documentationFileId}
						className={className}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
